import { SaiSurveyTerm as Term } from '../../../graphQL';

export const getTermOptions = () => {
  return Object.entries(Term).map(([key, value]) => ({
    id: value,
    label: key,
  }));
};

export const calculateYears = (
  startDate: string,
  term: Term
): { calendarYear: string; academicYearStart: string; academicYearEnd: string } => {
  if (!startDate) return { calendarYear: '', academicYearStart: '', academicYearEnd: '' };

  const calendarYearNum = new Date(startDate).getFullYear();

  let academicYearStartNum = 0;
  let academicYearEndNum = 0;
  if (term === Term.Fall) {
    academicYearStartNum = calendarYearNum;
    academicYearEndNum = calendarYearNum + 1;
  } else if (term === Term.Spring) {
    academicYearStartNum = calendarYearNum - 1;
    academicYearEndNum = calendarYearNum;
  }

  return {
    calendarYear: String(calendarYearNum),
    academicYearStart: academicYearStartNum ? String(academicYearStartNum) : '',
    academicYearEnd: academicYearEndNum ? String(academicYearEndNum) : '',
  };
};
